import styled from 'styled-components';

import { styledTypography } from '@pkg/primitives';

interface ModalStyleProps {
    $compact?: boolean;
}
export const Heading = styled.h1<ModalStyleProps>`
    ${styledTypography.allianceBase};
    font-weight: 700;
    letter-spacing: -0.03em;
    color: ${(props) => props.theme.colors.white};
    font-size: ${({ $compact }) => `${$compact ? 20 : 30}px`};
`;

export const SubHeading = styled.h2<ModalStyleProps>`
    ${styledTypography.allianceBase};
    letter-spacing: -0.03em;
    color: ${({ theme }) => theme.shades.white[50]};
    font-size: ${({ $compact }) => `${$compact ? 16 : 20}px`};
    font-weight: 400;
`;

export const CTAWrapper = styled.div<ModalStyleProps>`
    display: flex;
    flex-direction: ${({ $compact }) => ($compact ? 'row-reverse' : 'column')};
    gap: ${({ $compact }) => `${$compact ? 6 : 10}px`};
`;

export const CompactPadding = styled.div<ModalStyleProps>`
    padding: ${({ $compact }) => `${$compact ? '20px 0 30px' : '0'}`};
`;

export const FaceScreamingImage = styled.img<ModalStyleProps>`
    height: ${({ $compact }) => `${$compact ? 80 : 100}px`};
    width: ${({ $compact }) => `${$compact ? 80 : 100}px`};
`;
